export default {
   textShadow: '0 1px 0 rgba(0, 0, 0, 0.15)',
   dropShadow: [
      '0 1px 2px rgba(16, 22, 26, 0.1), 0 1px 4px rgba(0, 0, 0, 0.1)',
      '0 2px 6px rgba(16, 22, 26, 0.2), 0 1px 1px rgba(16, 22, 26, 0.2)',
      '0 6px 18px rgba(16, 22, 26, 0.2), 0 2px 4px rgba(16, 22, 26, 0.2)',
      '0 16px 36px rgba(16, 22, 26, 0.2), 0 3px 10px rgba(16, 22, 26, 0.2)',
   ],
};
